jQuery(function ($) {

    var selectedSellingPlanId = 8023310379;

    class SellingPlanHelper {

        static async getCartData() {
            const res = await fetch(`${window.Shopify.routes.root}cart.js`);

            if (!res.ok) {
                throw new Error('Failed to fetch cart: ', res.statusText);
            }

            return await res.json();
        }

        static async attachSellingPlanIDToCart(sellingPlanId) {
            try {
                CartHelper.setActionablesEnabled(false);
                const entries = [];

                const data = await this.getCartData();

                for (const item of data.items) {
                    const { variant_id, quantity, properties } = item;
                    entries.push({
                        id: variant_id,
                        quantity,
                        properties,
                        selling_plan: sellingPlanId,
                    });
                }

                const clearResponse = await fetch(`${window.Shopify.routes.root}cart/clear.js`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },

                });

                if (!clearResponse.ok) {
                    throw new Error('Failed to clear cart: ', clearResponse.statusText);
                }

                const addResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ items: entries }),
                });

                if (!addResponse.ok) {
                    throw new Error('Failed to update cart with selling plan ID: ', addResponse.statusText);
                }

                console.log('Selling plan update completed.');
            } catch (error) {
                throw error;
            } finally {
                CartHelper.setActionablesEnabled(true);
            }
        }

        static getSellingPlanLabel(sellingPlanId) {
            switch (sellingPlanId) {
                case 8023310379:
                    return 'Deliver every 1 week';
                case 8023343147:
                    return 'Deliver every 2 weeks';
                default:
                    return 'One time';
            }
        }
    }

    class CartHelper {
        static setActionablesEnabled(enabled) {
            const cart = document.querySelector('#slidecarthq');
            
            const items = cart.querySelector('.items');
            if (items) {
                const itemsActionables = items.querySelectorAll('button');
                itemsActionables.forEach(button => {
                    if (enabled == true) {
                        button?.removeAttribute('disabled');
                    } else {
                        button?.setAttribute('disabled', enabled);
                    }
                });
            }
        }
    }


    class CartItemsObserver extends MutationObserver {

        static instance;
        element;
        itemsCount = 0;

        constructor() {
            super(async (mutations) => {
                let addedNodes = false;
                for (const mutation of mutations) {
                    for (const node of mutation.addedNodes) {
                        if (node.classList?.[0] === 'item') {
                            addedNodes = true;
                        }
                    }
                }

                const currentItemsCount = this.element.querySelectorAll('.item')?.length ?? 0;
                
                if (addedNodes && currentItemsCount > this.itemsCount) {
                    const sellingPlanId = selectedSellingPlanId;
                    checkoutButtonObserver.setEnabled(false);
                    await SellingPlanHelper.attachSellingPlanIDToCart(sellingPlanId);
                    checkoutButtonObserver.setEnabled(true);
                    this.updateDeliveryFrequencyLabel(
                        SellingPlanHelper.getSellingPlanLabel(sellingPlanId)
                    );
                }
                this.itemsCount = currentItemsCount;
            });
        }

        startObserver(element) {
            this.element = element;

            if (!this.element) return;
            
            this.itemsCount = this.element.querySelectorAll('.item')?.length ?? 0;

            this.observe(this.element, { childList: true });

            console.log(this, 'started');
        }

        updateDeliveryFrequencyLabel(label) {
            if (!this.element) return;

            for (const item of this.element.children) {
                const ul = item.querySelector('ul.properties-key-value');
                const target = ul?.children?.[0]?.querySelector('.properties-key-value-value');
                if (!target || !ul) {
                    const ul = document.createElement('ul');
                    ul.classList.add('properties-key-value');
                    const li = document.createElement('li');
                    const span = document.createElement('span');
                    span.classList.add('properties-key-value-value');
                    span.innerHTML = label;
                    li.appendChild(span);
                    ul.appendChild(li);

                    const main = item.querySelector('.main-top-left');
                    main?.appendChild(ul);
                } else {
                    target.innerHTML = label;
                }
            }
        }

        static getInstance() {
            if (!this.instance) {
                this.instance = new CartItemsObserver();
            }

            return this.instance;
        }
    }


    class CheckoutButtonObserver extends MutationObserver {

        static instance;
        element;
        readyToBeModified = false;

        constructor() {
            super(mutations => {
                for (const mutation of mutations) {
                    if (mutation.target.classList.toString() === 'ZapietStack ZapietStack--spacing-tight' && $(mutation.target).find('.Zapiet-Select__Value').length > 0) {
                        this.readyToBeModified = true;
                        this.setEnabled(true);
                        this.disconnect();
                    }
                }
            });
        }

        setEnabled(value) {
            if (!this.readyToBeModified) return;
            const button = document.querySelector('button[value="Checkout"][name="checkout"]');
            if (value) {
                button.removeAttribute('disabled');
            } else {
                button.setAttribute('disabled', true);
            }
        }

        startObserver(element) {
            this.element = element;

            if (!this.element) return;

            this.observe(this.element, { subtree: true, childList: true });

            console.log(this, 'started');
        }

        static getInstance() {
            if (!this.instance) {
                this.instance = new CheckoutButtonObserver();
            }

            return this.instance;
        }
    }
    

    class SellingPlanSelector extends HTMLElement {
        
        #sellingPlans = {
            weekly: 8023310379,
            fortnightly: 8023343147,
            oneTime: null,
        }

        constructor() {
            super();

            const shadow = this.attachShadow({ mode: 'open' });
            this.subscriptionChoice = 'weekly';
            
            const container = document.createElement('div');
            container.classList.add('selling-plan-selector');

            const title = document.createElement('h5');
            title.classList.add('selling-plan--title');
            const titleText = document.createTextNode('Is this a one-time order or subscription?');
            title.append(titleText);

            container.append(title);

            const subscribeRadioGroup = document.createElement('label');
            subscribeRadioGroup.classList.add('radio-group');
            subscribeRadioGroup.classList.add('active');

            this.subscribeRadio = document.createElement('input');
            this.subscribeRadio.type = 'radio';
            this.subscribeRadio.name = 'subscribe';
            this.subscribeRadio.checked = true;

            const subscribeRadioText = document.createTextNode('Subscribe and get free delivery');

            const onetimeRadioGroup = document.createElement('label');
            onetimeRadioGroup.classList.add('radio-group');

            this.oneTimeRadio = document.createElement('input');
            this.oneTimeRadio.type = 'radio';
            this.oneTimeRadio.name = 'subscribe';

            const onetimeRadioText = document.createTextNode('One time');

            const subscriptionOptionsContainer = document.createElement('div');
            subscriptionOptionsContainer.classList.add('subscription-options');

            const weeklyRadioGroup = document.createElement('label');
            weeklyRadioGroup.classList.add('radio-group-child');

            this.weeklyRadio = document.createElement('input');
            this.weeklyRadio.type = 'radio';
            this.weeklyRadio.name = 'subscription_type';
            this.weeklyRadio.checked = true;
            this.weeklyRadio.dataset.value = true;

            const weeklyText = document.createTextNode('Every week');

            const fortnightlyRadioGroup = document.createElement('label');
            fortnightlyRadioGroup.classList.add('radio-group-child');

            this.fortnightlyRadio = document.createElement('input');
            this.fortnightlyRadio.type = 'radio';
            this.fortnightlyRadio.name = 'subscription_type';

            const fortnightlyText = document.createTextNode('Every 2 weeks');

            subscribeRadioGroup.appendChild(this.subscribeRadio);
            subscribeRadioGroup.appendChild(subscribeRadioText);

            onetimeRadioGroup.appendChild(this.oneTimeRadio);
            onetimeRadioGroup.appendChild(onetimeRadioText);
            
            weeklyRadioGroup.appendChild(this.weeklyRadio);
            weeklyRadioGroup.appendChild(weeklyText);
            subscriptionOptionsContainer.appendChild(weeklyRadioGroup);

            fortnightlyRadioGroup.append(this.fortnightlyRadio);
            fortnightlyRadioGroup.append(fortnightlyText);
            subscriptionOptionsContainer.appendChild(fortnightlyRadioGroup);

            container.appendChild(subscribeRadioGroup);
            container.appendChild(subscriptionOptionsContainer);
            container.appendChild(onetimeRadioGroup);

            shadow.innerHTML = `
                <style>
                    .selling-plan-selector {
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                        margin-bottom: 32px;
                    }
                    .selling-plan--title {
                        font-size: 16px;
                        margin-bottom: 32px;
                    }
                    .subscription-options {
                        margin-top: 4px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-bottom: 20px;
                        height: auto;
                        overflow: hidden;
                        transition: height 150ms, margin-top 150ms;
                    }
                    .radio-group {
                        border: solid 2px #dcdcdc;
                        padding: 11px 10px;
                        display: block;
                        margin-bottom: 5px;
                        border-radius: 4px;
                        font-size: 10pt;
                        color: #0f2a06;
                        cursor: pointer;
                        transition: border-color 150ms;
                    }
                    .radio-group.active {
                        border-color: #8080d2;
                    }
                    .radio-group-child {
                        width: calc(42% - 5px);
                        font-size: 10pt;
                        text-align: center;
                    }
                    .subscription-options:not(:has(input[data-value='true'])) {
                        height: 0;
                        margin-top: 0;
                    }
                    .radio-group input[type='radio'],
                    .radio-group-child input[type='radio'] {
                        margin: 3px 5px;
                    }
                    .radio-group.disabled,
                    .radio-group-child.disabled {
                        border: solid 2px #dcdcdc;
                    }
                </style>
            `;
            shadow.append(container);

            this.onSelectSubscribeDefault = this.onSelectSubscribeDefault.bind(this);
            this.onSelectOneTime = this.onSelectOneTime.bind(this);
            this.onSelectFortnightly = this.onSelectFortnightly.bind(this);
            this.resetSelections = this.resetSelections.bind(this);
            this.setActive = this.setActive.bind(this);
        }

        connectedCallback() {
            this.subscribeRadio.addEventListener('change', e => this.onSelectSubscribeDefault(e));
            this.oneTimeRadio.addEventListener('change', e => this.onSelectOneTime(e));
            this.weeklyRadio.addEventListener('change', e => this.onSelectSubscribeDefault(e));
            this.fortnightlyRadio.addEventListener('change', e => this.onSelectFortnightly(e));

            this.onLoad();
        }

        disconnectedCallback() {
            this.subscribeRadio.removeEventListener('change', e => this.onSelectSubscribeDefault(e));
            this.oneTimeRadio.removeEventListener('change', e => this.onSelectOneTime(e));
            this.weeklyRadio.removeEventListener('change', e => this.onSelectSubscribeDefault(e));
            this.fortnightlyRadio.removeEventListener('change', e => this.onSelectFortnightly(e));
        }

        setLoading(isLoading) {
            const inputs = [
                this.subscribeRadio,
                this.oneTimeRadio,
                this.weeklyRadio,
                this.fortnightlyRadio,
            ];

            for (let input of inputs) {
                input.ariaDisabled = isLoading;

                if (isLoading) {
                    input.setAttribute('disabled', true);
                } else {
                    input.removeAttribute('disabled');
                }
            }

            if (isLoading) {
                this.subscribeRadio.parentElement.classList.add('disabled');
                this.oneTimeRadio.parentElement.classList.add('disabled');
            } else {
                this.subscribeRadio.parentElement.classList.remove('disabled');
                this.oneTimeRadio.parentElement.classList.remove('disabled');
            }
        }

        resetSelections() {
            this.shadowRoot.querySelectorAll('input[type="radio"').forEach(el => {
                el.checked = false;
                el.dataset.value = false;
            });
            this.shadowRoot.querySelectorAll('label').forEach(el => {
                el.classList.remove('active');
            });
        }

        setActive(e) {
            this.resetSelections();
            e.target.checked = true;
            e.target.dataset.value = true;
            
            if (e.target.name === 'subscription_type') {
                const parent = this.subscribeRadio;
                parent.parentElement.classList.add('active');
                parent.checked = true;
            }

            if (e.target === this.subscribeRadio) {
                const weekly = this.weeklyRadio;
                const fortnightly = this.fortnightlyRadio;
                if (!weekly.checked && !fortnightly.checked) {
                    weekly.checked = true;
                    weekly.dataset.value = true;
                }
            }

            if (e.target.name === 'subscribe') {
                e.target.parentElement.classList.add('active');
            }
        }

        setActiveUsingSellingPlan(sellingPlanId) {
            switch (sellingPlanId) {
                case this.#sellingPlans.weekly:
                        this.weeklyRadio.checked = true;
                        this.subscribeRadio.checked = true;
                        this.subscribeRadio.classList.add('active');

                        this.oneTimeRadio.checked = false;
                        this.oneTimeRadio.parentElement.classList.remove('active');
                    break;
                case this.#sellingPlans.fortnightly:
                        this.fortnightlyRadio.checked = true;
                        this.subscribeRadio.checked = true;
                        this.subscribeRadio.classList.add('active');

                        this.oneTimeRadio.checked = false;
                        this.oneTimeRadio.parentElement.classList.remove('active');
                    break;
            }
            selectedSellingPlanId = sellingPlanId;
        }

        async onLoad() {
            this.setLoading(true);
            try {
                const data = await SellingPlanHelper.getCartData();

                // Check if there's existing selling plan ID on items
                let existing_selling_plan_id;
                if (
                    data.items.some(item => {
                        existing_selling_plan_id = item.selling_plan_allocation?.selling_plan?.id;
                        return item.selling_plan_allocation?.selling_plan?.id;
                    })
                ) {
                    this.setActiveUsingSellingPlan(existing_selling_plan_id);
                    return;
                } else {
                    this.subscribeRadio.checked = true;
                    const event = new Event('change', { bubbles: true });
                    this.subscribeRadio.dispatchEvent(event);
                }
            } catch (error) {
                console.log('Error: ', error);
            } finally {
                this.setLoading(false);
            }
        }

        async attachSellingPlanIDToCart(sellingPlanId) {
            selectedSellingPlanId = sellingPlanId;
            this.setLoading(true);
            try {
                checkoutButtonObserver.setEnabled(false);
                await SellingPlanHelper.attachSellingPlanIDToCart(sellingPlanId);
                cartItemsObserver.updateDeliveryFrequencyLabel(
                    SellingPlanHelper.getSellingPlanLabel(selectedSellingPlanId)
                );
            } catch (error) {
                console.error('Error: ', error);
            } finally {
                this.setLoading(false);
                checkoutButtonObserver.setEnabled(true);
            }
        }

        async onSelectSubscribeDefault(e) {
            this.setActive(e);
            await this.attachSellingPlanIDToCart(this.#sellingPlans.weekly);
        }

        async onSelectOneTime(e) {
            this.setActive(e);
            await this.attachSellingPlanIDToCart(this.#sellingPlans.oneTime);
        }

        async onSelectFortnightly(e) {
            this.setActive(e);
            await this.attachSellingPlanIDToCart(this.#sellingPlans.fortnightly);
        }
    }

    if (!customElements.get('selling-plan-selector')) {
        customElements.define('selling-plan-selector', SellingPlanSelector);
    }

    const cartItemsObserver = CartItemsObserver.getInstance();
    const checkoutButtonObserver = CheckoutButtonObserver.getInstance();

    function attachSellingPlanSelectorUI() {
        cartItemsTriggerObserver.observe(document.querySelector('.slidecarthq'), { childList: true, subtree: true, attributes: true });
        cartCheckoutTriggerObserver.observe(document.querySelector('#slidecarthq'), { childList: true, subtree: true });

        $('#storePickupApp').append('<selling-plan-selector />');
        const button = document.querySelector('button[value="Checkout"][name="checkout"]');
        button?.setAttribute('disabled', true);
    }

    const sellingPlanSelectorObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            if (mutation.target.id === 'storePickupApp') {
                if (!document.querySelector('selling-plan-selector')) {
                    attachSellingPlanSelectorUI();
                }
            }
        }
    });
    sellingPlanSelectorObserver.observe(document.body, { childList: true, subtree: true });


    const cartItemsTriggerObserver = new MutationObserver(mutations => {
        let target;
        for (const mutation of mutations) {
            const _target = mutation.target.querySelector('.items');
            if (_target || mutation.target?.classList?.[0] === 'items') {
                target = _target;
                break;
            }
            for (const node of mutation.addedNodes) {
                if (typeof node.querySelector === 'function') {
                    const _target = node?.querySelector('.items');
                    if (_target || node?.classList?.[0] === 'items') {
                        target = _target;
                        break;
                    }
                }
            }
            if (target) {
                break;
            }
        }

        if (target) {
            cartItemsObserver.startObserver(target);
            cartItemsTriggerObserver.disconnect();
        }
    });

    
    const cartCheckoutTriggerObserver = new MutationObserver(mutations => {
        for (const mutation of mutations) {
            if (mutation.target.id === 'storePickupApp') {
                checkoutButtonObserver.startObserver(mutation.target);
                cartCheckoutTriggerObserver.disconnect();
            }
        }
    });

});